export {
  payrollAgreementListScreen,
  payrollAgreementDetailScreen,
} from './payroll-agreement.screen';
export { payrollAgreementSearch, payrollAgreementDetailSearch } from './payroll-agreement.search';
export { loadPayrollAgreementMessages } from './payroll-agreement.catalog';
export const loadPayrollAgreementScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadPayrollAgreementGuides = () => import('./payroll-agreement.guide');
